/** EN catalog — Follow-ups / Clinic CRM (ZOY-712): the worklist, the record sheet, Add to CRM. */
export const crmEn: Record<string, string> = {
  'nav.followups': 'Follow-ups',
  'cal.followups': 'Follow-ups',

  /* ── worklist ─────────────────────────────────────────────────────────── */
  'crm.title': 'Follow-ups',
  'crm.sub': 'People to call back, book, register and connect — one line each.',
  'crm.new': 'New follow-up',
  'crm.tab.open': 'Open',
  'crm.tab.closed': 'Closed',
  'crm.who.mine': 'Mine',
  'crm.who.all': 'Everyone',
  'crm.due.any': 'Any date',
  'crm.due.overdue': 'Overdue',
  'crm.due.today': 'Due today',
  'crm.due.week': 'Next 7 days',
  'crm.due.none': 'No date',
  'crm.f.linked': 'Patient',
  'crm.f.linked.any': 'Any',
  'crm.f.linked.none': 'No patient yet',
  'crm.f.linked.guest': 'Guest',
  'crm.f.linked.registered': 'Registered',
  'crm.f.req': 'Family request',
  'crm.f.req.any': 'Any',
  'crm.f.req.yes': 'Has a request',
  'crm.f.req.no': 'No request',
  'crm.searchPh': 'Search name or phone',
  'crm.col.who': 'Who',
  'crm.col.next': 'Next step',
  'crm.col.note': 'Latest note',
  'crm.col.patient': 'Patient',
  'crm.col.visit': 'Visit',
  'crm.col.request': 'Family request',
  'crm.emptyTitle': 'Nothing here',
  'crm.emptyBody': 'No follow-up matches these filters.',
  'crm.emptyOpenTitle': 'No open follow-ups',
  'crm.emptyOpenBody': 'Family requests you add, and calls you log, appear here.',
  'crm.unassigned': 'Unassigned',
  'crm.noNextAction': 'No next step',
  'crm.noDate': 'no date',
  'crm.dueTone.overdue': 'Overdue',
  'crm.dueTone.today': 'Today',
  'crm.noNote': 'No note yet',
  'crm.noteBy': '{name} · {when}',
  'crm.noPatient': 'Not a patient yet',
  'crm.linked.guest': 'Guest',
  'crm.linked.registered': 'Registered · file {n}',
  'crm.linked.registeredNoFile': 'Registered',
  'crm.linked.merged': 'Merged into another record',
  'crm.connected': 'Connected',
  'crm.visit.next': 'Next {when}',
  'crm.visit.last': 'Last {when} · {status}',
  'crm.visit.none': '—',
  'crm.req.badge': 'Request · {status}',
  'crm.req.status.pending': 'pending',
  'crm.req.status.expired': 'expired',
  'crm.req.status.withdrawn': 'withdrawn',
  'crm.req.status.declined': 'declined',
  'crm.req.status.accepted': 'accepted',
  'crm.req.status.cancelled': 'cancelled',
  'crm.req.status.superseded': 'replaced',
  'crm.closedAs': 'Closed · {reason}',
  'crm.reason.converted': 'Became a patient',
  'crm.reason.connected': 'Family connected',
  'crm.reason.not_interested': 'Not interested',
  'crm.reason.unreachable': 'Unreachable',
  'crm.reason.duplicate': 'Duplicate',
  'crm.reason.other': 'Other',
  'crm.source.family_request': 'Family request',
  'crm.source.phone_call': 'Phone call',
  'crm.source.walk_in': 'Walk-in',
  'crm.source.referral': 'Referral',
  'crm.source.other': 'Other',

  /* ── new follow-up ────────────────────────────────────────────────────── */
  'crm.newTitle': 'New follow-up',
  'crm.newSub': 'Name and number are enough — the rest has sensible defaults.',
  'crm.name': 'Name',
  'crm.nameHelp': 'Whoever you will call — a parent’s name is fine.',
  'crm.phone': 'Phone',
  'crm.phoneHelp': 'The number to call back.',
  'crm.source': 'How they reached us',
  'crm.due': 'Follow up on',
  'crm.assignee': 'Assigned to',
  'crm.more': 'More',
  'crm.less': 'Less',
  'crm.firstNote': 'First note',
  'crm.nextActionText': 'What to do next',
  'crm.nextActionPh': 'e.g. call back about speech therapy',
  'crm.create': 'Create follow-up',
  'crm.created': 'Follow-up created.',
  'crm.phoneTooShort': 'This doesn’t look like a phone number yet — enter at least 5 digits.',

  /* ── candidates ───────────────────────────────────────────────────────── */
  'crm.cand.title': 'This number is already known',
  'crm.cand.body':
    'Choose the record this belongs to, or create a new one. Nothing is linked until you choose.',
  'crm.cand.records': 'Follow-ups holding this number',
  'crm.cand.patients': 'Patients holding this number',
  'crm.cand.match.phone': 'same number',
  'crm.cand.match.account': 'same family account',
  'crm.cand.attach': 'Attach here',
  'crm.cand.open': 'Open',
  'crm.cand.forPatient': 'New follow-up for this patient',
  'crm.cand.new': 'Create a new follow-up',
  'crm.cand.closedNote': 'closed — will be reopened',
  'crm.cand.state.open': 'open',
  'crm.cand.state.closed': 'closed',

  /* ── requests inbox ───────────────────────────────────────────────────── */
  'crm.req.add': 'Add to Follow-ups',
  'crm.req.in': 'In Follow-ups',
  'crm.req.added': 'Added to Follow-ups.',
  'crm.req.attached': 'Attached to the existing follow-up.',
  'crm.req.reopened': 'The follow-up was closed — it is open again.',

  /* ── the record sheet ─────────────────────────────────────────────────── */
  'crm.sheet.title': 'Follow-up',
  'crm.sheet.close': 'Close',
  'crm.sheet.status.open': 'Open',
  'crm.sheet.status.closed': 'Closed',
  'crm.sheet.since': 'Since {when}',
  'crm.sheet.assignMe': 'Assign to me',
  'crm.sheet.nextAction': 'Next step',
  'crm.sheet.dueDate': 'Due',
  'crm.sheet.preset.today': 'Today',
  'crm.sheet.preset.tomorrow': 'Tomorrow',
  'crm.sheet.preset.in3': 'In 3 days',
  'crm.sheet.preset.nextWeek': 'Next week',
  'crm.sheet.preset.clear': 'No date',
  'crm.sheet.saved': 'Saved',
  'crm.sheet.quickNote': 'Add a note',
  'crm.sheet.quickNotePh':
    'What was said, what was agreed… (Enter saves, Shift+Enter for a new line)',
  'crm.sheet.noteSave': 'Save note',
  'crm.sheet.noteEdit': 'Edit',
  'crm.sheet.noteRemove': 'Remove',
  'crm.sheet.noteRemoveTitle': 'Remove this note?',
  'crm.sheet.noteRemoveBody': 'It leaves the record; the wording stays in the audit trail.',
  'crm.sheet.edited': 'edited',
  'crm.sheet.timeline': 'Notes and history',
  'crm.sheet.timelineEmpty': 'Nothing yet — add the first note.',
  'crm.sheet.patient': 'Patient',
  'crm.sheet.openPatient': 'Open the record',
  'crm.sheet.createGuest': 'Create Guest',
  'crm.sheet.linkExisting': 'Link existing patient',
  'crm.sheet.relink': 'Change patient',
  'crm.sheet.bookVisit': 'Book visit',
  'crm.sheet.connect': 'Connect family',
  'crm.sheet.connectHint':
    'Connect from the patient’s Family tab — the family’s number must be on the record as the contact mobile or a caregiver’s number.',
  'crm.sheet.attachRequest': 'Attach the pending request from {name}',
  'crm.sheet.requests': 'Family requests',
  'crm.sheet.reqLine': '{name} · {mobile} · {status}',
  'crm.sheet.reqExpires': 'expires {when}',
  'crm.sheet.message': 'Their message: {text}',
  'crm.sheet.closeCta': 'Close follow-up',
  'crm.sheet.reopen': 'Reopen',
  'crm.sheet.closeTitle': 'Close this follow-up',
  'crm.sheet.closeBody':
    'It leaves the open list and keeps its history. It can be reopened any time.',
  'crm.sheet.closeReason': 'Reason',
  'crm.sheet.closeNote': 'Note (optional)',
  'crm.sheet.closed': 'Closed.',
  'crm.sheet.reopened': 'Reopened.',
  'crm.sheet.promptConnected': 'Family connected. Close this follow-up as “Family connected”?',
  'crm.sheet.promptRegistered': 'Patient registered. Close this follow-up as “Became a patient”?',
  'crm.sheet.promptClose': 'Close it',
  'crm.sheet.stale':
    'Someone else changed this follow-up meanwhile — it was reloaded. Apply your change again.',
  'crm.sheet.fullDetails': 'Full details',

  /* ── Guest from record ────────────────────────────────────────────────── */
  'crm.guest.title': 'Create a Guest',
  'crm.guest.sub':
    'The child’s own name — a follow-up is often in a parent’s name. A Guest can be booked; registration comes later.',
  'crm.guest.first': 'Child’s first name',
  'crm.guest.last': 'Child’s last name',
  'crm.guest.contact': 'Contact mobile',
  'crm.guest.contactHelp':
    'Prefilled from the follow-up; change it if the record’s number differs.',
  'crm.guest.caregiverTitle': 'Caregiver on the record',
  'crm.guest.caregiverHelp':
    'Prefilled from the family request. Choose the relationship to add them; leave it blank to skip.',
  'crm.guest.cgName': 'Caregiver name',
  'crm.guest.cgMobile': 'Caregiver mobile',
  'crm.guest.cgRelationship': 'Relationship',
  'crm.guest.cgSkip': '— not now —',
  'crm.guest.create': 'Create Guest',
  'crm.guest.created': 'Guest created and linked.',
  'crm.guest.dupTitle': 'A similar patient already exists',
  'crm.guest.dupBody': 'Link the existing patient instead of creating a second one.',

  /* ── link existing ────────────────────────────────────────────────────── */
  'crm.link.title': 'Link an existing patient',
  'crm.link.body':
    'Choose the patient this follow-up is about. Guests and registered patients both qualify.',
  'crm.link.byPhone': 'Holding this number',
  'crm.link.byPhoneNone': 'No patient holds this number.',
  'crm.link.search': 'Search a patient',
  'crm.link.searchHelp': 'Name or file number.',
  'crm.link.searchNone': 'No patient matches.',
  'crm.link.pick': 'Choose',
  'crm.link.picked': 'Chosen',
  'crm.link.confirm': 'Link this patient',
  'crm.link.linked': 'Patient linked.',
  'crm.link.needsChoice': 'Choose a patient first.',
  'crm.link.reason': 'Why (optional)',

  /* ── patient record card ──────────────────────────────────────────────── */
  'crm.card.title': 'Follow-up',
  'crm.card.open': 'Open in Follow-ups',

  /* ── booking desk ─────────────────────────────────────────────────────── */
  'crm.res.new': 'New follow-up',

  /* ── errors ───────────────────────────────────────────────────────────── */
  'crm.err.gone': 'That follow-up no longer exists — the list has been refreshed.',
  'crm.err.noteGone': 'That note was already removed — the record has been refreshed.',
  'crm.err.closed': 'This follow-up is closed — reopen it first.',
  'crm.err.notClosed': 'This follow-up is not closed.',
  'crm.err.alreadyLinked':
    'A patient is already linked to this follow-up — the record has been refreshed.',
  'crm.err.stale':
    'Someone else changed this follow-up meanwhile — reloaded; apply your change again.',
  'crm.err.notRequest': 'That row is not a family request.',
  'crm.err.attachedElsewhere': 'That request already belongs to another follow-up.',
  'crm.err.phone':
    'This number could not be read as a phone number — enter it with its area code, e.g. 021… or 0912….',
  'crm.err.patientGone': 'That patient no longer exists.',
  'crm.err.patientMerged': 'That patient was merged into another record — link the surviving one.',
  'crm.err.requestGone': 'That family request no longer exists — the inbox has been refreshed.',
  'crm.err.refused': 'The clinic system refused this change — nothing you typed was lost.',

  /* ── timeline events ──────────────────────────────────────────────────── */
  'crm.ev.record_created': 'Follow-up created',
  'crm.ev.source_family_request': 'Family request added',
  'crm.ev.source_phone_call': 'Phone call logged',
  'crm.ev.source_walk_in': 'Walk-in logged',
  'crm.ev.source_referral': 'Referral logged',
  'crm.ev.source_other': 'Source added',
  'crm.ev.request_pending': 'Request pending',
  'crm.ev.request_expired': 'Request expired',
  'crm.ev.request_withdrawn': 'Request withdrawn by the family',
  'crm.ev.request_declined': 'Request declined',
  'crm.ev.request_accepted': 'Request accepted',
  'crm.ev.request_cancelled': 'Request cancelled',
  'crm.ev.patient_created': 'Guest created',
  'crm.ev.patient_registered': 'Patient registered',
  'crm.ev.booking_booked': 'Visit booked',
  'crm.ev.booking_cancelled': 'Visit cancelled',
  'crm.ev.booking_no_show': 'Visit — no-show',
  'crm.ev.connected': 'Family connected',
  'crm.ev.closed': 'Closed',
  'crm.ev.other': 'Update',

  /* ── assignment ───────────────────────────────────────────────────────── */
  'crm.assign.none': 'Unassigned',
  'crm.assign.me': 'Me',
};
